import React, { forwardRef } from "react";
import { darken, makeStyles } from "@material-ui/core";
import styled from "styled-components";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import StyledIconButton from "./buttons/StyledIconButton";
import { MdAdd, MdArrowUpward } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "0.5rem 1rem",
  },
  chatInputContainer: {
    position: "relative",
    width: "100%",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "12px",
    overflow: "hidden",
  },
  leftActionContainer: {
    position: "absolute",
    left: "0.25rem",
    bottom: "0.25rem",
    padding: "0.25rem",
  },
  rightActionContainer: {
    position: "absolute",
    right: "0.25rem",
    bottom: "0.25rem",
    padding: "0.25rem",
  },
  submitAction: {
    backgroundColor: (props) => props.themeColor || undefined,
    "&:hover": {
      backgroundColor: (props) => darken(props.themeColor, 0.2) || undefined,
    },
    color: "#ffff",
    transition: "all 0.5s",
  },
  loadingDots: {
    width: "16px",
    height: "100%",
    paddingBlock: "6px",
  },
}));

export default forwardRef(function ChatInput(props, ref) {
  const {
    themeColor,
    showNewChat,
    isSubmitDisabled,
    loading,
    onNewChatClick,
    ...restProps
  } = props;

  const classes = useStyles({ themeColor });

  const handleClickNewChat = () => {
    onNewChatClick();
  };
  const renderChatInput = () => {
    return (
      <div className={classes.container}>
        <div className={classes.chatInputContainer}>
          {showNewChat && (
            <div className={classes.leftActionContainer}>
              <StyledIconButton onClick={handleClickNewChat}>
                <MdAdd size={16} />
              </StyledIconButton>
            </div>
          )}
          <StyledTextArea
            ref={ref}
            style={{ paddingLeft: showNewChat ? "3.25rem" : undefined }}
            {...restProps}
          />
          <div className={classes.rightActionContainer}>
            <StyledIconButton
              type="submit"
              color="primary"
              disabled={isSubmitDisabled}
              className={classes.submitAction}
            >
              <MdArrowUpward color="inherit" size={16} />
            </StyledIconButton>
          </div>
        </div>
      </div>
    );
  };

  return renderChatInput();
});

const StyledTextArea = styled(TextareaAutosize)`
  && {
    width: 100%;
    padding: 0.8rem 3rem 0.5rem 1.25rem;
    font-size: 14px;
    border: 0px solid transparent;
    outline: none;
    resize: none;

    &::-webkit-scrollbar {
      width: 8px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      background-color: lightgray;
      border-radius: 4px;
      cursor: pointer;
    }

    &:disabled {
      color: gray;
    }
  }
`;
